import React from "react";
import { Container, Grid } from "@mui/material";
import MetaTags from "react-meta-tags";
import { Link } from "react-router-dom";

import { Title, LeadingText, Text, blue, lightblue } from "../theme/theme";

const ContactPost = () => {
  return (
    <>
      <MetaTags>
        <title>Bedankt | MEEtec</title>
        <meta name="description" content="Bedankt voor je bericht." />
        {/* Nothing here belongs in search results, and an indexed confirmation
            page reaches people who never sent anything. */}
        <meta name="robots" content="noindex" />
      </MetaTags>

      <div style={{ background: lightblue }}>
        <Container>
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <br />
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={3} lg={3}>
              <br />
              <Title color={blue}>Bedankt</Title>
            </Grid>
            <Grid item xs={12} sm={12} md={9} lg={7}>
              <br />
              <LeadingText color={blue}>
                We hebben je bericht goed ontvangen.
              </LeadingText>
              <br />
              <Text color={blue}>
                Een van onze medewerkers neemt zo snel mogelijk contact met je
                op. Heb je een dringende vraag? Bel ons gerust rechtstreeks.
              </Text>
              <br />
              <br />
              <Link to="/" style={{ textDecoration: "underline" }}>
                <Text color={blue}>Terug naar de website</Text>
              </Link>
            </Grid>
          </Grid>
          <br />
          <br />
          <br />
          <br />
        </Container>
      </div>
    </>
  );
};

export default ContactPost;
